var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gift_block" }, [
    _c("div", { staticClass: "categories" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { staticClass: "form-label" }, [
          _vm._v(_vm._s(_vm.__t("PRODUCTS"))),
        ]),
        _vm._v(" "),
        _c("v-select", {
          staticClass: "imc_reasons",
          attrs: {
            multiple: "",
            filterable: false,
            label: "title",
            options: _vm.products_search_options,
          },
          on: { search: _vm.onSearch, input: _vm.emitUpdate },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (option) {
                return [
                  _c("div", { staticClass: "d-center" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(option.title) +
                        "\n                    "
                    ),
                    _c("div", [
                      _c("small", [_vm._v(_vm._s(option.uniq_id))]),
                      _vm._v(" "),
                      option.hasOwnProperty("prov_type")
                        ? _c("small", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(option.prov_type) +
                                "\n                        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.block.products,
            callback: function ($$v) {
              _vm.$set(_vm.block, "products", $$v)
            },
            expression: "block.products",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.is_catalog
      ? _c(
          "div",
          { staticClass: "form-group d-flex align-items-center mt-2" },
          [
            _c("yes_no", {
              key: "IS_CHOICE",
              attrs: { title: "IS_CHOICE" },
              on: {
                input: function (val) {
                  return _vm.update("on_choice", val)
                },
              },
              model: {
                value: _vm.block.on_choice,
                callback: function ($$v) {
                  _vm.$set(_vm.block, "on_choice", $$v)
                },
                expression: "block.on_choice",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm.is_catalog
        ? _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.__t("DISCOUNT_PERCENT"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_catalog
        ? _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.__t("MIN_ORDER_SUM"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.block.min_order,
            expression: "block.min_order",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "number", min: 1, max: _vm.is_catalog ? 100 : 10000 },
        domProps: { value: _vm.block.min_order },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.block, "min_order", $event.target.value)
            },
            _vm.emitUpdate,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-danger btn-sm",
        on: {
          click: function ($event) {
            return _vm.$emit("remove")
          },
        },
      },
      [_vm._v("\n        " + _vm._s(_vm.__t("REMOVE")) + "\n    ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }